import {useEffect, useMemo, useRef} from 'react';
import {
  Conversation,
  InlineDataConversationMessage,
} from '@stripe-internal/conversations-client';
import {LiveAnswersRow} from '../../../Chat/Row/LiveAnswersRow';

type Props = {
  conversation: Conversation;
  message: InlineDataConversationMessage;
};

export function InlineDataMessageLiveAnswersRow({
  conversation,
  message,
}: Props) {
  const {liveAnswersMessage, liveAnswersClient, onDoneStreaming, onError} =
    useMemo(() => {
      return conversation.streamLiveAnswersMessage(message);
    }, [conversation, message]);

  const doneRef = useRef<boolean>(false);

  useEffect(() => {
    if (
      liveAnswersMessage.data?.is_complete &&
      !message.inlineData.isDone &&
      !doneRef.current
    ) {
      doneRef.current = true;
      onDoneStreaming({
        content: liveAnswersMessage.data.content,
        sources: liveAnswersMessage.sources,
      });
    }
  }, [liveAnswersMessage, message.inlineData.isDone, onDoneStreaming]);

  const {data: liveAnswersData} = liveAnswersMessage;
  const liveAnswersMessageDone =
    liveAnswersData?.is_complete ||
    liveAnswersData?.was_halted ||
    liveAnswersData?.not_answerable;
  if (message.inlineData.isDone && !liveAnswersMessageDone) {
    // This indicates an error state. For the inline data to be marked done but the
    // data is not completed streaming, that means something went wrong.
    return null;
  }

  return (
    <LiveAnswersRow
      conversation={conversation}
      liveAnswersMessage={liveAnswersMessage}
      liveAnswersClient={liveAnswersClient}
      onDoneStreaming={onDoneStreaming}
      onError={onError}
    />
  );
}
